import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../context/AuthContext";

const LogoutButton = () => {
  const { logout } = useAuth();

  return (
    <Button
      onClick={logout}
      variant="text"
      color="inherit"
      startIcon={<LogoutIcon sx={{ fontSize: "1.2rem" }} />}
      sx={{
        textTransform: "none",
        fontSize: "0.9rem",
        padding: "6px 12px",
      }}
    >
      LOGOUT
    </Button>
  );
};

export default LogoutButton;
